import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FileAuthorization } from '../../../models/dataloadmanagement.model';

export interface EditFileAuthorizationData {
  fileAuthorization: FileAuthorization;
  clientName?: string;
}

export interface EditFileAuthorizationResult {
  loadToleranceDays: number | null;
  autoProcessFiles: boolean;
  comment?: string;
}

@Component({
  selector: 'app-editfileauthorization',
  standalone: false,
  templateUrl: './editfileauthorization.component.html',
  styleUrl: './editfileauthorization.component.css'
})
export class EditfileauthorizationComponent {
  private static readonly MAX_INT_VALUE = 2147483647;
  @Output() submitRequest = new EventEmitter<EditFileAuthorizationResult>();
  loadToleranceDays: number | null;
  loadToleranceDaysStr: string;
  autoProcessFiles: boolean;
  comment: string;
  validationError = '';
  dialogError = '';

  constructor(
    public dialogRef: MatDialogRef<EditfileauthorizationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EditFileAuthorizationData
  ) {
    this.loadToleranceDays = data.fileAuthorization.LoadToleranceDays ?? null;
    this.loadToleranceDaysStr = this.loadToleranceDays !== null ? String(this.loadToleranceDays) : '';
    this.autoProcessFiles = data.fileAuthorization.AutoProcessFiles ?? false;
    this.comment = data.fileAuthorization.Comment ?? '';
  }

  onToleranceInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const digits = input.value.replace(/\D/g, '');
    input.value = digits;
    this.loadToleranceDaysStr = digits;
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    const parsed = this.loadToleranceDaysStr === '' ? null : Number(this.loadToleranceDaysStr);
    if (parsed !== null && parsed < 0) {
      this.validationError = 'Load Tolerance Days must be a non-negative number.';
      return;
    }
    if (parsed !== null && parsed > EditfileauthorizationComponent.MAX_INT_VALUE) {
      this.validationError = 'Load Tolerance Days cannot be greater than 2147483647 (maximum value of Int32).';
      return;
    }
    this.validationError = '';
    this.dialogError = '';
    const result: EditFileAuthorizationResult = {
      loadToleranceDays: parsed,
      autoProcessFiles: this.autoProcessFiles,
      comment: this.comment.trim()
    };
    this.submitRequest.emit(result);
  }
}
